import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=e9b6bdfe&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=ts"
export * from "./Cart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b6bdfe",
  null
  
)

export default component.exports